// /frontend/components/fca/FCADirectsTable.jsx
import React from 'react';
import {
  Table, TableHead, TableBody, TableRow, TableCell,
  Paper
} from '@mui/material';
import TableViewport from '../common/TableViewport';
import { formatNumber } from '../../utils/format';

export default function FCADirectsTable({ rows }) {
  const fmt = (n, d=2) => formatNumber(n || 0, { digits: d });

  return (
    <TableViewport footerPadPx={0} component={Paper} elevation={1}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>SKU</TableCell>
            <TableCell align="right">Units</TableCell>
            <TableCell align="right">Revenue</TableCell>
            <TableCell align="right">Fulfill</TableCell>
            <TableCell align="right">Transport</TableCell>
            <TableCell align="right">Storage</TableCell>
            <TableCell align="right">Total (Directs)</TableCell>
            <TableCell align="right">Cost/Unit (Directs)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(r => (
            <TableRow key={r.sku}>
              <TableCell>{r.sku}</TableCell>
              <TableCell align="right">{fmt(r.units_sold, 0)}</TableCell>
              <TableCell align="right">{fmt(r.revenue_net)}</TableCell>
              <TableCell align="right">{fmt(r.alloc_fulfill_net)}</TableCell>
              <TableCell align="right">{fmt(r.alloc_transport_net)}</TableCell>
              <TableCell align="right">{fmt(r.alloc_storage_net)}</TableCell>
              <TableCell align="right">{fmt(r.total_directs)}</TableCell>
              <TableCell align="right">{fmt(r.cost_per_unit_directs, 4)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableViewport>
  );
}
